import "ladda/css/ladda.scss"
import "./forms/validation"

import * as Ladda from "ladda"

// ─── Quantity Group Elements ────────────────────────────────────────────────────
export function initQtyInputGroups() {

    Array.prototype.slice.call(document.querySelectorAll(".quantity-input-group"))
        .map((container) => ({
            input: container.querySelector(".quantity-input"),
            decrease: container.querySelector(".minus-btn"),
            increase: container.querySelector(".plus-btn"),
            get value() { return parseInt(this.input.value) },
            set value(v) { this.input.value = v }
        }))
        .forEach(item => (
            item.decrease.addEventListener("click", () => (item.value > 1) && (item.value -= 1)),
            item.increase.addEventListener("click", () => item.value += 1)
        ))

}


// ─── INITIALISE LADDA BUTTONS ───────────────────────────────────────────────────
export function initLaddaButtons() {
    Array.from(document.getElementsByClassName("ladda-button")).forEach(el =>
        el.dataset.style = "zoom-in"
    )
    window.Ladda = Ladda //Allows other scripts to access global Ladda object
    Ladda.bind(".ladda-button")
}



//When ordering option is changed on shop page, JS click the filter button
$("#ordering").on("change", function () {
    var $btn = $(this).parents("form").find(".ladda-button")
    $btn.click();
})


//'Show/ hide password buttons
$(".show-password").on("click", function (e) {
    const targetName = $(this).data("password")
    const target = $(`#${targetName}`)

    const targetType = target.prop("type")
    switch (targetType) {
        case "password":
            target.prop("type", "text")
            $(this).html(`<i class="far fa-eye-slash"></i>`)
            break;
        case "text":
            target.prop("type", "password")
            $(this).html(`<i class="far fa-eye"></i>`)
            break;
    }
})

if ($("#edit-address-form").length > 0) {

    const $countryField = $("#country_id");
    const $stateField = $("#state_id");
    const $zipField = $("#postcode");
    const $stateWrapper = $stateField.closest(".col-md");

    function toggleStateField() {
        //NOT USA
        if ($countryField.val() != 237) {
            $stateWrapper.hide(); // Hide the parent wrapper
            $stateField.removeAttr("data-rule-required");
            $zipField.attr("data-rule-maxlength", "10");
            $zipField.attr("data-msg-maxlength", "10 characters max");

        } else {
            //USA
            $stateWrapper.show(); // Show the parent wrapper
            $stateField.attr("data-rule-required", "true");
            $zipField.attr("data-rule-maxlength", "5");
            $zipField.attr("data-msg-maxlength", "5 characters max");
        }
    }

    // Initial check on page load
    toggleStateField();

    // Recheck when the country selection changes
    $countryField.on("change", toggleStateField);

}

